<template>
    <div class="form-group">
        <label>{{ label }}</label>
        <p class="help-block small" v-html="helpBlock" v-if="helpBlock"></p>
        <input type="hidden" :name="inputName" :value="tagInput">
        <div class="tag-container">
            <vue-tags-input
                v-model="tag"
                :tags="tags"
                :add-on-key="triggerKeys"
                :placeholder="placeholder"
                :avoid-adding-duplicates="false"
                @tags-changed="newTags => tags = newTags"
            />
        </div>
    </div>
</template>

<script>
    import VueTagsInput from '@sipec/vue3-tags-input'

    export default {
        name: "TagsInputField",
        components: {
            VueTagsInput
        },
        props: {
            label: String,
            helpBlock: String,
            placeholder: String,
            data: String,
            inputName: String
        },
        mounted () {
            if (!!this.data) {
                this.addExistingDataToTags()
            }
        },
        data () {
            return {
                tag: '',
                tags: [],
                tagInput: null,
                triggerKeys: [13, 32, 188], // Enter, Space & ,
            }
        },
        methods: {
            addExistingDataToTags () {
                let dataArray = _.split(this.data, ', ')
                _.each(dataArray, (item) => {
                    this.tags.push({ text: item })
                })
            }
        },
        watch: {
            tags (values) {
                this.tagInput = _.join(_.map(values, 'text'), ', ')
                this.$emit('selected', this.tagInput)
            }
        }
    }
</script>

<style lang="less">
    .help-block {
        margin-top: 5px;
        margin-bottom: 10px;
    }

    .vue-tags-input {
        max-width: 100% !important;

        .ti-input {
            min-height: 40px;
            border-radius: 4px;
            border-color: #d9d9d9;

            .ti-tag {
                background-color: #5cc4e8;

                &.ti-deletion-mark, &.ti-duplicate, &.ti-invalid {
                    background-color: #f46464;
                }
            }
        }
    }
</style>
